import moment from 'moment';
import { Select } from '@treams/treams-ui';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import * as graphql from 'generated/graphql';
import useLocalize from 'packages/kakapo-ui-application/hooks/useLocalize';

export default function EngagementRequestFilter(props: {
	value?: string;
	templateID?: string;
	onSelect: (requestID?: string) => void;
}) {
	const { t } = useTranslation();
	const { localize } = useLocalize();

	const [fetch, query] = graphql.useEngagementRequestsLazyQuery({
		variables: {
			templateID: props.templateID,
			first: 10_000,
		},
	});

	return (
		<Select
			selectedOption={
				props.value
					? undefined
					: {
							title: t('analytics.metric.engagement.filters.request.all'),
							value: undefined,
					  }
			}
			selectedValue={props.value}
			options={
				query.data
					? [
							{
								title: t('analytics.metric.engagement.filters.request.all'),
								value: undefined,
							},
							undefined,
							..._.sortBy(
								query.data?.engagementRequests.edges.map(({ node }) => ({
									title: t('analytics.metric.engagement.filters.request.title', {
										date: moment(node.createdAt).format('LL'),
									}),
									value: node.id,
									description: node.template?.title
										? t('analytics.metric.engagement.filters.request.description', {
												template: localize(node.template?.title).text,
										  })
										: '',
								})),
								'createdAt',
							).reverse(),
					  ]
					: undefined
			}
			fetch={fetch}
			onChange={(value) => props.onSelect(value!)}
		/>
	);
}
